import { Divider, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { NOT_SAVED_ID } from "app/model"
import { getFormatedNumber } from "app/tools/number"
import { CURRENCIES } from "currency/model"
import { convertValueIntoCurrency } from "currency/tools/common"
import { IFormInventory } from "form/inventory/model"
import { getCurrencySymbol, getCurrentFormCurrencyId, getInventoryECPM } from "form/inventory/tools/common"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ThreeDotLoader } from "ui/components/ThreeDotLoader"
import { FormInventoryBudget } from "./FormInventoryBudget"
import { FormInventoryCpmForecast } from "./FormInventoryCpmForecast"

interface IFormInventoryMoneyProps {
  inventory: IFormInventory
  contentWidth: number
}

export const FormInventoryMoney = React.memo(
  ({ inventory, contentWidth }: IFormInventoryMoneyProps): JSX.Element | null => {
    const { tempCampaignId: campaignId, isRefreshing } = inventory
    const isCampaignSaved = campaignId !== NOT_SAVED_ID
    const areDataInitialized = isCampaignSaved
    const currencySymbol = getCurrencySymbol(getCurrentFormCurrencyId())
    const isWidthNotSmall = contentWidth > 435
    const isWidthNotMedium = contentWidth > 740
    return (
      <FlexBox
        sx={{
          maxWidth: "calc(100% - 3rem)",
          borderRadius: ".25rem",
          minHeight: "5rem",
          maxHeight: "5rem",
          p: ".5rem",
          pl: "1rem",
          pr: "1rem",
          backgroundColor: theme => theme.palette.background.default
        }}>
        {isWidthNotMedium && <FormInventoryBudget />}
        {areDataInitialized ? (
          <>
            {isWidthNotMedium && (
              <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: "1rem", mr: "1rem" }} />
            )}
            <FlexBox vertical ai="start" jc="space-between" sx={{ minWidth: "9rem" }}>
              <Typography fontWeight={500} fontSize=".9rem" sx={{ color: theme => theme.palette.text.primary2 }}>
                {translate("label.ecpm.average")}
              </Typography>
              <FlexBox ai="start">
                <Typography
                  fontSize="2rem"
                  fontWeight={500}
                  sx={{ lineHeight: "2rem", color: theme => theme.palette.text.primary2 }}>
                  {currencySymbol}
                </Typography>
                {isRefreshing ? (
                  <ThreeDotLoader sx={{ transform: "scale(.5)", m: "0.5rem", ml: "1rem", height: "1rem" }} />
                ) : (
                  <Typography
                    fontWeight={500}
                    fontSize="2rem"
                    sx={{
                      lineHeight: "2rem",
                      color: theme => theme.palette.text.primary2
                    }}>
                    {getFormatedNumber(
                      convertValueIntoCurrency(CURRENCIES.CAD, getCurrentFormCurrencyId(), getInventoryECPM(inventory))
                    )}
                  </Typography>
                )}
              </FlexBox>
            </FlexBox>
            {isWidthNotSmall && <FormInventoryCpmForecast />}
          </>
        ) : !isWidthNotSmall ? (
          <Typography fontWeight={500} fontSize=".75rem" sx={{ color: theme => theme.palette.text.primary2 }}>
            {translate("label.budget.no.data")}
          </Typography>
        ) : null}
      </FlexBox>
    )
  }
)
